import script from "./ParameterLists.vue?vue&type=script&setup=true&lang=js"
export * from "./ParameterLists.vue?vue&type=script&setup=true&lang=js"

import "./ParameterLists.vue?vue&type=style&index=0&id=365d6df2&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365d6df2"]])

export default __exports__